var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgAddSale = function SvgAddSale(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00B361",
    d: "M17.12.606c-.818-.781-2.106-.781-2.924 0l-1.18 1.18c-.074.075-.117.177-.117.284v2.356c0 .222.18.403.403.403h2.357c.107 0 .21-.042.285-.118l1.179-1.179c.808-.806.809-2.115.002-2.923l-.002-.003h-.003z",
    opacity: 0.5,
    transform: "matrix(-1 0 0 1 19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B361",
    d: "M13.302 0h-3.22c-.221 0-.401.18-.401.403v3.219c0 .184.125.345.304.39l3.22.805c.031.007.064.011.097.012.222 0 .402-.18.402-.403V.403c0-.223-.18-.403-.402-.403z",
    opacity: 0.5,
    transform: "matrix(-1 0 0 1 19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B361",
    d: "M11.172 4.141L7.15.118c-.157-.157-.412-.157-.569 0L4.166 2.532c-.157.157-.157.412 0 .569l1.61 1.61c.075.075.177.117.283.118h4.829c.222 0 .402-.18.403-.402 0-.107-.043-.21-.119-.286z",
    opacity: 0.5,
    transform: "matrix(-1 0 0 1 19 0)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#00B361",
    opacity: 0.5,
    transform: "matrix(-1 0 0 1 19 0) translate(4.828 15.277)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.083,
    cy: 2.025,
    r: 2.012
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.036,
    cy: 2.025,
    r: 2.012
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#03B361",
    d: "M18.432 4.16c-.077-.087-.187-.136-.302-.136H3.645c-.222 0-.402.18-.402.403 0 .024.002.049.007.073l1.207 6.438c.036.19.202.328.395.328h11.052c1.015 0 1.87-.755 1.997-1.762l.631-5.028c.014-.115-.023-.23-.1-.316z",
    transform: "matrix(-1 0 0 1 19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#03B361",
    d: "M16.52 14.485H7.234c-1.341-.003-2.495-.949-2.761-2.263L2.51 2.414H.426c-.222 0-.402-.18-.402-.402 0-.222.18-.402.402-.402H2.84c.192 0 .356.134.395.322L5.26 12.063c.19.94 1.014 1.615 1.972 1.617h9.288c.222 0 .402.18.402.403 0 .222-.18.402-.402.402z",
    transform: "matrix(-1 0 0 1 19 0)"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddSale, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add_sale.63feac03.svg";
export { ForwardRef as ReactComponent };